import React, { useState } from "react";
import tw from "twin.macro";
import { SectionHeading } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { Container, ContentWithVerticalMargin } from "components/misc/Layouts.js";
import ImagePlots from "images/plots_plan.jpg";

const Row = tw.div`flex flex-col lg:flex-row justify-between items-center lg:pt-16 max-w-screen-2xl mx-auto sm:px-8`;
const Column = tw.div``;
const TextColumn = tw(Column)`mr-auto lg:mr-0 max-w-lg lg:max-w-xl xl:max-w-2xl`;
const Heading = tw(SectionHeading)`text-left text-primary-900 leading-snug xl:text-6xl`;
const Description = tw(SectionDescription)`mt-4 lg:text-base text-gray-700 max-w-lg`;

// Mobile-friendly image column and container
const ImageColumn = tw(Column)`
  w-full mt-8 lg:mt-0 lg:ml-auto lg:mr-0 lg:ml-32
  px-4 sm:px-0
`;
const ImageContainer = tw.div`
  relative z-40
  w-full max-w-sm mx-auto
  sm:max-w-md md:max-w-lg lg:max-w-none lg:w-144
  lg:transform lg:xl:-translate-x-24 lg:xl:-translate-y-16
`;
const Image = tw.img`
  w-full h-auto max-w-full
  rounded-t sm:rounded
  relative z-20 cursor-pointer
  transition-transform duration-200 hover:scale-105
`;

// Modal styles with mobile improvements
const ModalOverlay = tw.div`
  fixed inset-0 bg-black bg-opacity-75
  flex items-center justify-center z-50
  p-2 sm:p-4
`;
const ModalContent = tw.div`
  relative max-w-full max-h-full
  w-full h-full flex items-center justify-center
`;
const ModalImage = tw.img`
  max-w-full max-h-full object-contain rounded
  w-auto h-auto
`;
const CloseButton = tw.button`absolute right-0 top-0 m-2 text-white bg-red-600 rounded-full w-8 h-8 flex items-center justify-center hover:bg-opacity-75 transition-colors duration-200`;

export default () => {
  const [isZoomed, setIsZoomed] = useState(false);

  const handleImageClick = () => {
    setIsZoomed(true);
  };

  const handleCloseZoom = () => {
    setIsZoomed(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setIsZoomed(false);
    }
  };

  // Handle escape key to close modal
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isZoomed) {
        setIsZoomed(false);
      }
    };

    if (isZoomed) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isZoomed]);

  return (
    <>
      <Container>
        <ContentWithVerticalMargin>
          <Row>
            <TextColumn>
              <Heading>Welcome to Aspen Green.</Heading>
              <Description>
                Homeowners!, we're thrilled to have you here. You'll find everything you need in one place—community events, amenities, calendars, historical docs, online voting, and a lot more.
              </Description>
              <Description>
                The site's pretty easy to navigate, but if you have any questions or need a hand setting up your account, just shoot us an email at president.agcoa@gmail.com.
              </Description>
              <Description>
                For visitors and future homeowners, feel free to check out our public pages to get a sneak peek at our community and everything we offer!
              </Description>
            </TextColumn>
            <ImageColumn>
              <ImageContainer>
                <Image
                  src={ImagePlots}
                  onClick={handleImageClick}
                  alt="Aspen Green plots plan"
                />
              </ImageContainer>
            </ImageColumn>
          </Row>
        </ContentWithVerticalMargin>
      </Container>

      {/* Zoom Modal */}
      {isZoomed && (
        <ModalOverlay onClick={handleOverlayClick}>
          <ModalContent>
            <CloseButton onClick={handleCloseZoom}>
              ×
            </CloseButton>
            <ModalImage
              src={ImagePlots}
              alt="Aspen Green plots plan - enlarged view"
            />
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};
